import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const rowCardDefaultVariants = {}
const rowCardCompoundVariants = []

const rowCardSlotNames = [
  [
    "root",
    "row-card__root"
  ],
  [
    "title",
    "row-card__title"
  ],
  [
    "imageWrapper",
    "row-card__imageWrapper"
  ],
  [
    "image",
    "row-card__image"
  ],
  [
    "label",
    "row-card__label"
  ]
]
const rowCardSlotFns = /* @__PURE__ */ rowCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, rowCardDefaultVariants, getSlotCompoundVariant(rowCardCompoundVariants, slotName))])

const rowCardFn = memo((props = {}) => {
  return Object.fromEntries(rowCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const rowCardVariantKeys = []
const getVariantProps = (variants) => ({ ...rowCardDefaultVariants, ...compact(variants) })

export const rowCard = /* @__PURE__ */ Object.assign(rowCardFn, {
  __recipe__: false,
  __name__: 'rowCard',
  raw: (props) => props,
  variantKeys: rowCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, rowCardVariantKeys)
  },
  getVariantProps
})